const dataHeader = {
  logoMotto: 'Înflorește-ți viața',
  exactPath: {
    path: '/',
    name: 'Acasă'
  },
  links: [
    {
      path: '/servicii',
      name: 'Servicii'
    },{
      path: '/contact',
      name: 'Contact'
    },{
      path: '/despre-noi',
      name: 'Despre Noi'
    },
  ]
};

export default dataHeader;
